export default {"src":"https://search.prod.wiggot.com/_next/static/media/monpolioLabel.54126256.svg","height":21,"width":111,"blurWidth":0,"blurHeight":0};